import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { Button, Col, Row, Spinner } from "reactstrap";
import * as Yup from "yup";
import { getUserById, updateUser } from "../../../../../api/usersAPIs";
import { PreviewCard } from "../../../../../components/Component";
import Content from "../../../../../layout/content/Content";

const UpdateUserPage = () => {
    const { userId } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                setLoading(true);
                const response = await getUserById(userId);
                setUser(response.data.data);
            } catch (error) {
                toast.error("Failed to fetch user data");
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [userId]);

    const initialValues = {
        first_name: user?.first_name || "",
        last_name: user?.last_name || "",
        email: user?.email || "",
        phone: user?.phone || "",
        role: user?.role || "",
    };

    const validationSchema = Yup.object({
        first_name: Yup.string().required("First name is required"),
        last_name: Yup.string().required("Last name is required"),
        email: Yup.string().email("Invalid email format").required("Email is required"),
        phone: Yup.string()
            .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
            .required("Phone number is required"),
        role: Yup.string().required("Role is required"),
    });

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            await updateUser(userId, values);
            toast.success("User updated successfully");
            navigate("/customer");
        } catch (error) {
            toast.error("Failed to update user");
        } finally {
            setLoading(false);
        }
    };

    if (!user) {
        return (
            <Content>
                <Spinner color="primary" />
            </Content>
        );
    }

    return (
        <Content className="container mt-5">
            <PreviewCard>
                <h3>Update User</h3>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Row className="g-3" xs={1}>
                                <Col size="6">
                                    <label>First Name</label>
                                    <Field name="first_name" className="form-control" placeholder="Enter first name" />
                                    <ErrorMessage name="first_name" component="div" className="text-danger" />
                                </Col>

                                <Col size="6">
                                    <label>Last Name</label>
                                    <Field name="last_name" className="form-control" placeholder="Enter last name" />
                                    <ErrorMessage name="last_name" component="div" className="text-danger" />
                                </Col>

                                <Col size="6">
                                    <label>Email</label>
                                    <Field name="email" type="email" className="form-control" placeholder="Enter email" />
                                    <ErrorMessage name="email" component="div" className="text-danger" />
                                </Col>

                                <Col size="6">
                                    <label>Phone</label>
                                    <Field name="phone" className="form-control" placeholder="Enter phone number" />
                                    <ErrorMessage name="phone" component="div" className="text-danger" />
                                </Col>

                                {/* <Col size="6">
                                    <label>Role</label>
                                    <Field as="select" name="role" className="form-control">
                                        <option value="">Select Role</option>
                                        <option value="Admin">Admin</option>
                                        <option value="User">User</option>
                                    </Field>
                                    <ErrorMessage name="role" component="div" className="text-danger" />
                                </Col> */}

                                <Col size="12">
                                    <div className="d-flex justify-content-end">
                                        <Button color="primary" type="submit" disabled={isSubmitting || loading}>
                                            {loading ? <Spinner size="sm" /> : "Update User"}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </PreviewCard>
        </Content>
    );
};

export default UpdateUserPage;
